/**
 * Doc-match relevance thresholds — dependency-free so pure-lib and
 * component-layer modules (e.g. lib/coverage/requirementStatus) can share
 * the single source of truth without importing the scorer service.
 * `services/docMatching/relevanceScoring.ts` re-exports these unchanged.
 */

/** Score thresholds — single source of truth, referenced by DM3 + DM4. */
export const PRIMARY_SCORE_THRESHOLD = 0.7;
export const SUPPORTING_SCORE_THRESHOLD = 0.4;

/**
 * SED D0.3 (extraction recall) — single source of truth for the floor
 * at which a matched doc is BOTH counted as a DCT match AND attempted
 * for doc extraction.
 *
 * Before D0.3 the SAME axis (`doc.relevance[reportType]`) was gated by
 * three different numbers: DCT called a doc a "match" at ≥ 0.4
 * (`SUPPORTING_SCORE_THRESHOLD`), the extractor refused to attempt
 * below 0.6 (`docQualifiesForFallback`/`pickBestFallbackDoc` defaults),
 * and the verified-section boost used yet a third floor ≥ 0.3. Every
 * doc whose relevance landed in [0.4, 0.6) was therefore "matched but
 * not extracted" by construction — the recall gap D0.3 closes.
 *
 * Aliasing `SUPPORTING_SCORE_THRESHOLD` keeps the "is this a match?"
 * decision a SINGLE tunable number: an admin who lowers the DCT
 * supporting threshold also lowers the extraction-attempt floor, which
 * is coherent (they are the same axis). `PRIMARY_SCORE_THRESHOLD`
 * (0.7) is untouched — it gates the distinct primary-vs-supporting
 * role, not extraction.
 */
export const EXTRACTION_RELEVANCE_FLOOR = SUPPORTING_SCORE_THRESHOLD;
